import { render, staticRenderFns } from "./Water.vue?vue&type=template&id=67f58c61&scoped=true"
import script from "./Water.vue?vue&type=script&lang=js"
export * from "./Water.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f58c61",
  null
  
)

export default component.exports